/* eslint no-use-before-define: 0 */  // --> OFF
<template>
  <form @submit.prevent="confirm()">
    <div>
      <div>
        <div class="form-group">
          <label for="nom">Nom du maîtrise</label>
          <input type="text" class="form-control" id="nom" v-model="maitrise.nom" maxlength="50" required>
        </div>

        <div class="form-group">
          <label for="prenom">Prénom du maîtrise</label>
          <input type="text" class="form-control" id="prenom" v-model="maitrise.prenom" maxlength="50" required>
        </div>

        <div class="form-group">
          <label for="cantonnier">Ville</label>
          <select v-model="selectedVille" class="form-control" id="ville" v-on:change="onVilleChange()" required>
            <option v-for="ville in villes.data" v-bind:value="ville" v-bind:item="ville" v-bind:key="ville.id">
              {{ ville.nom.toUpperCase() }}
            </option>
          </select>
        </div>

        <label for="arrondissement">Arrondissement de rattachement</label>
        <div v-for="(arr, value) in arrondissements" v-bind:key="value">
          <div class="radio">
            <label>
              <input type="radio" name="arrondissement" v-bind:value="arr.id" v-model="maitrise.arrondissement_id" required>
              {{arr.nom}}
            </label>
          </div>
        </div>

        <div class="form-group">
          <label for="telephone">Numéro de téléphone</label>
          <input type="text" class="form-control" id="telephone" v-model="maitrise.telephone" pattern="^[0][0-9]{9}$"
                 oninvalid="this.setCustomValidity('Vous devez renseigner 10 caractères numériques et le premier doit être un 0')" oninput="setCustomValidity('')" required>
        </div>

        <div class="form-group">
          <label for="login">Email</label>
          <input type="email" class="form-control" id="email" v-model="maitrise.email" v-bind:disabled="maitriseUpdate && maitriseUpdate.id !== currentUser.id" maxlength="50"
                 pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" oninvalid="this.setCustomValidity('Vous devez renseigner une adresse email valide')" oninput="setCustomValidity('')" required>
          <div class="invalid-feedback" v-if="emailExists" style="color: red;">
            Un maitrise avec le même email existe déjà dans la base de données !
          </div>
        </div>


        <div class="form-group">
          <label for="login">Login</label>
          <input type="text" class="form-control" id="login" v-model="maitrise.login" pattern=".{6,50}" v-bind:disabled="maitriseUpdate && maitriseUpdate.id !== currentUser.id"
                 oninvalid="this.setCustomValidity('Vous devez renseigner au moins 6 caractères')" oninput="setCustomValidity('')" required>
          <div class="invalid-feedback" v-if="loginExists" style="color: red;">
            Un maitrise avec le même login existe déjà dans la base de données !
          </div>
        </div>

        <div class="form-group">
          <label for="password">Mot de passe</label>
          <input type="password" class="form-control" id="password" v-model="maitrise.password"
                 pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$">
        </div>

        <div v-if="!maitriseUpdate && showCollectivity">
          <label for="collectivite">Profil collectivité ?</label>
          <div>
            <div class="radio">
              <label>
                <input id="isCollectivite" type="radio" name="isCollectivite" value="true" v-model="maitrise.isCollectivite" v-on:change="handleRadioChange()" required>
                Oui
              </label>
            </div>
            <div class="radio">
              <label>
                <input type="radio" name="isCollectivite" value="false" v-model="maitrise.isCollectivite" v-on:change="handleRadioChange()" required>
                Non
              </label>
            </div>
          </div>
        </div>


        <label>Activer les droits d'administration générale ?</label>
        <div>
          <div class="radio">
            <label>
              <input id="isSuperAdmin" type="radio" name="isSuperAdmin" v-model="maitrise.isSuperAdmin" v-on:change="handleRadioChangeAdmin()" value="true"  required :disabled="adminRadioDisabled">
              Oui
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" name="isSuperAdmin" v-model="maitrise.isSuperAdmin" v-on:change="handleRadioChangeAdmin()" value="false" required :disabled="adminRadioDisabled">
              Non
            </label>
          </div>
        </div>
      </div>

      <div class="buttons">
        <button class="btn btn-primary">Confirmer</button>
        <div class="btn btn-default" v-on:click="$emit('close')">
          Annuler
        </div>
      </div>
    </div>
  </form>
</template>


<script>
/* eslint-disable */
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapState([
      'villes',
      'adminUsers',
      'currentUser',
      'currentVille',
    ]),
  },
  props: [
    'maitriseUpdate',
  ],
  data: function () {
    return {
      maitrise: this.maitriseUpdate ? _.cloneDeep(this.maitriseUpdate) : {
        isSuperAdmin: false, // Set the default value
        isCollectivite:false
      },
      selectedVille: null,
      arrondissements: [],
      emailExists: false,
      loginExists: false,
      adminRadioDisabled: false,
      showCollectivity: false,
    }
  },
  methods: {
    confirm: function () {
      var self = this

      this.maitrise.isSuperAdmin = (this.maitrise.isSuperAdmin === "false") ? false : true
      this.maitrise.isCollectivite = (this.maitrise.isCollectivite === "false") ? false : true

      this.loginExists =  this.adminUsers.data.find(
        (maitrise) => maitrise.login === this.maitrise.login.trim() && maitrise.id !== this.maitrise.id
      )

      this.emailExists = this.adminUsers.data.find(
        (maitrise) => maitrise.email === this.maitrise.email.trim() && maitrise.id !== this.maitrise.id
      );

      console.log("what im gonna do with this =======",this.maitrise)
      if (this.maitriseUpdate && !this.emailExists && !this.loginExists)
      {
        console.log("modal user sent ========",this.maitrise)
        this.$store.dispatch('updateUser',this.maitrise).then(() => {
          self.$emit('close')
        })
      }
      else if (!this.maitriseUpdate && !this.emailExists && !this.loginExists) {
        console.log("creation modal user sent ========",this.maitrise)
        this.$store.dispatch('createUser', this.maitrise).then(function () {
          self.$emit('close')
        })
      }
    },
    onVilleChange: function () {
      this.maitrise.ville_id = this.selectedVille.id
      this.arrondissements = this.selectedVille.arrondissements.sort((a, b) => a.nom.localeCompare(b.nom))
      if (!this.maitriseUpdate)
        this.maitrise.arrondissement_id = this.arrondissements[0].id
      if(this.selectedVille.parametragebos.find(param => param.parametrageBOMenu === "COLLECTIVITE" && param.actif))
      {
        this.showCollectivity = true
      }else {
        this.showCollectivity = false
        this.adminRadioDisabled = false
      }
    },
    handleRadioChange() {
      if (this.maitrise.isCollectivite === 'true') {
        this.adminRadioDisabled = true
        this.maitrise.isSuperAdmin = undefined
        this.maitrise.isSuperAdmin = 'false';
      } else {
        this.adminRadioDisabled = false
      }
      console.log("MAITTTTTTTTTTT",this.maitrise)
    },
    handleRadioChangeAdmin() {
      console.log("MAITTTTTTTTTTT ADMIN",this.maitrise)
    },
  },
  mounted: function () {

    if (!this.maitriseUpdate){
      this.selectedVille = this.villes.data.find(ville => ville.id === this.currentVille.id)
      this.maitrise.ville_id = this.selectedVille.id
      this.arrondissements = this.selectedVille.arrondissements.sort((a, b) => a.nom.localeCompare(b.nom))
      this.maitrise.arrondissement_id = this.arrondissements[0].id
      if(this.selectedVille.parametragebos.find(param => param.parametrageBOMenu === "COLLECTIVITE" && param.actif))
      {
        this.showCollectivity = true
      }
      else {
        this.showCollectivity = false
      }
    }

    delete this.maitrise.password
    if (this.maitrise && this.maitrise.jwtAuthorities) {
      this.maitrise.isSuperAdmin = this.maitrise.jwtAuthorities.find(authority =>
        authority.jwtRole === 'ADMIN') ? true : false

      if(this.maitrise.jwtAuthorities.find(authority => authority.jwtRole === 'COLLECTIVITY_USER'))
      {
        this.adminRadioDisabled = true
        this.maitrise.isSuperAdmin = false
      }
      if (this.maitrise.ville_id) {
        this.selectedVille = this.villes.data.find(v => v.id === this.maitrise.ville_id)
        this.arrondissements = this.selectedVille.arrondissements.sort((a, b) => a.nom.localeCompare(b.nom))
      }
    }
  },
}

</script>



// WEBPACK FOOTER //
// UserForm.vue?76a4ce53